const ColorList = {
    "light": {
        heroSectionBgColor : "rgb(201,173,167)",
        heroSectionColor: "rgb(34,34,59)",

        cashReturnBgColor : "rgb(214, 203, 203)",
        cashReturnColor: "rgb(0, 55, 95)",

        luckyBgColor : "rgb(255, 255, 144)",
        luckyColor : "rgb(71, 109, 2)",

        groceryBgColor : "rgb(167,201,87)",
        groceryColor : "black"
    },
    "dark" : {
        heroSectionBgColor : "rgb(34,34,59)",
        heroSectionColor : "rgb(201,173,167)",

        cashReturnBgColor : "rgb(0, 24, 41)",
        cashReturnColor: "rgb(201,173,167)",

        luckyBgColor : "rgb(40, 63, 0)",
        luckyColor : "rgb(255, 255, 144)",

        groceryBgColor : "black",
        groceryColor : "white"
    }
}
export default ColorList;